import { render, staticRenderFns } from "./VoiceRecords.vue?vue&type=template&id=04cd2b9c&"
import script from "./VoiceRecords.vue?vue&type=script&lang=js&"
export * from "./VoiceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports